import createIcon from '../../createIcon';

/**
 * @component @name Texture
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTkuNTEgMy4wOEwzLjA4IDE5LjUxQzMuMTcgMTkuODUgMy4zNSAyMC4xNiAzLjU5IDIwLjQxQzMuODQgMjAuNjUgNC4xNSAyMC44MyA0LjQ5IDIwLjkyTDIwLjkzIDQuNDlDMjAuNzQgMy44IDIwLjIgMy4yNiAxOS41MSAzLjA4Wk0xMS44OCAzTDMgMTEuODhWMTQuNzFMMTQuNzEgM0gxMS44OFpNNSAzQzMuOSAzIDMgMy45IDMgNVY3TDcgM0g1Wk0xOSAyMUMxOS41NSAyMSAyMC4wNSAyMC43OCAyMC40MSAyMC40MUMyMC43OCAyMC4wNSAyMSAxOS41NSAyMSAxOVYxN0wxNyAyMUgxOVpNOS4yOSAyMUgxMi4xMkwyMSAxMi4xMlY5LjI5TDkuMjkgMjFaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Texture = createIcon('Texture', [
  [
    'path',
    {
      d: 'M19.51 3.08L3.08 19.51C3.17 19.85 3.35 20.16 3.59 20.41C3.84 20.65 4.15 20.83 4.49 20.92L20.93 4.49C20.74 3.8 20.2 3.26 19.51 3.08ZM11.88 3L3 11.88V14.71L14.71 3H11.88ZM5 3C3.9 3 3 3.9 3 5V7L7 3H5ZM19 21C19.55 21 20.05 20.78 20.41 20.41C20.78 20.05 21 19.55 21 19V17L17 21H19ZM9.29 21H12.12L21 12.12V9.29L9.29 21Z',
      key: '3hhl14',
    },
  ],
]);

export default Texture;
